import React from 'react';

const CurrentLevelContext = React.createContext(0);

export default CurrentLevelContext;
